export default __webpack_public_path__ + "static/media/FER.2c8c5c41.svg";